// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"197":"75fc9c18","293":"component---src-pages-index-js","387":"fcfa8dee"}[chunkId] + "-" + {"197":"074a285317b2bf4eb0fb","293":"040fe92e7d632954fc9d","387":"78011b704b54e346a550"}[chunkId] + ".js";
};